/**
 * File listeners.js.
 *
 * Contains various listeners for monitoring changes and interactions
 * on the site.
 */

( function( $ ) {
	var $shareLinks = $('.card__link--share');
	var $slider = $('.testimonial-slider');
	var $callout = $('#masthead').find('.callout');
	var xhr;

	setMenuStyle();

	$(window).on('scroll', function() {
		setMenuStyle();
	});

	$(window).on('resize', function() {
		setMenuStyle();

		// Reset the position of the card footer on resize so the correct
		// height can be calculated and equalized
		$('.recent-news').find('.card').find('.card__footer').css({
			position: 'relative'
		});
	});

	// Hide callout
	$callout.find('.close-button').on('click', function() {
		$('body').removeClass('has-callout');
		document.cookie = "callout_hidden=true"
		document.cookie = "callout_id=" + $callout[0].id;
	});

	// Toggle the mobile menu
	$('#menu-toggle').on('click', function(event) {
		$('body').toggleClass('nav-open');
	});

	// Scroll to content
	$('.page-header .scroll').on('click', function(event) {
		event.preventDefault();

		var solidMenuHeight = 80;
		if (Foundation.MediaQuery.current === 'small') {
			solidMenuHeight = 50;
		}

		$('html, body').animate({
			scrollTop: $('.page-header').outerHeight() - solidMenuHeight
		}, 1200);
	});

	// Expands and shrinks the pricing tables on mobile devices
 	$('.pricing-table__expand').on('click', function(event) {
 		var table = $(event.target).parents('.pricing-table');

 		if (table.length > 0) {
 			togglePricingTable(table, event.target);
 		}
 	});

 	// Equalizer listener for card footers
	$('.recent-news').on('postequalized.zf.equalizer', function(event) {
		$(event.target).find('.card').find('.card__footer').css({
			position: 'absolute'
		});
	});

	if ($shareLinks.length > 0) {
		$(document).on('click', function(event) {
			var $linkContainer;
			var show = false;

			if ($(event.target).hasClass('card__link--share')) {
				$linkContainer = $(event.target).next('.share-button__link-container');

				if ($linkContainer.length > 0) {
					show = !$linkContainer.hasClass('share-button__link-container--visible');
				}
			}

			$('.share-button__link-container--visible').removeClass('share-button__link-container--visible');

			if (show) {
				$linkContainer.addClass('share-button__link-container--visible');
			}
		});
	}

	// Social sharing link listeners
	$('.share-button__link--facebook').on('click', function(event) {
		//Creating a share url
		var url = 'https://www.facebook.com/sharer/sharer.php';

		//Adding the arguments to the share url
		url += '?url=' + encodeURIComponent($(event.target).parents('.share-button__link-container')[0].dataset.url);

		displaySharePopUp(url);
	});

	$('.share-button__link--twitter').on('click', function(event) {
		//Create a share url
		var url = 'https://twitter.com/intent/tweet';

		//Add the arguments to the share url
		url += '?url=' + encodeURIComponent($(event.target).parents('.share-button__link-container')[0].dataset.url);

		displaySharePopUp(url);
	});

	// Testimonial Slider
	if ($slider.length > 0) {
		$slider.slick({
			infinite: true,
			prevArrow: '<button class="prev"><i class="material-icons">&#xE5CB;</i></button>',
			nextArrow: '<button class="next"><i class="material-icons">&#xE5CC;</i></button>',
			responsive: [
				{
					breakpoint: 640,
					settings: {
						adaptiveHeight: true
					}
				}
			]
		});
	}

	
	/*	TRIAL SIGNUP
	***********************************************/
	var $startingForm = $('#trial-signup-start');
	var $signupForm = $('#trial-signup');

	$startingForm.on('submit', function(event) {
		event.preventDefault();
		$signupForm.find('input#email').val($startingForm.find('input#start-email').val());
		$('#trial-modal').modal('show');
	});

	$signupForm.on('submit', function(event) {
		event.preventDefault();

		// Abort if a previous request is active
		if (xhr){
			return;
		}

		var $button = $signupForm.find('.button');
		var buttonContent = $button.html();

		// Add spinner to button and fade out any visible form errors
		$button.addClass('loading').html('<span class="spinner2"></span>');
		$signupForm.find('.form-error, .form-response').fadeOut(300);

		var formData = $signupForm.serialize();

		// Submit form data
		xhr = $.ajax({
			url: ajaxURL,
			type: 'POST',
			dataType: 'JSON',
			data: 'action=signup_form_submit&'+formData,
			success: function(result) {
 				// Reset button text
				$button.removeClass('loading').html(buttonContent);

				if (result.valErrors && Object.keys(result.valErrors).length > 0) {
					// Update an error text and fade in the error text
					var keys = Object.keys(result.valErrors);

					for (var i = 0; i < keys.length; i++) {
						$(event.target).find('input[name="' + keys[i] + '"], textarea[name="' + keys[i] + '"]').next('.form-error').text(result.valErrors[keys[i]]).fadeIn(300);
					}
				}

				// Display response
				$signupForm.find('.form-response').text(result.message).removeClass('success error').addClass(result.status).fadeIn(300);

				xhr = null;
			},
			error: function() {
				$button.html(buttonContent);

				// Display response
				$signupForm.find('.form-response').text('An unknown error occurred.').removeClass('success error').addClass('error').fadeIn(300);

				xhr = null;
			}
		});
	});

} )( jQuery );